const BASE_PATH_ROLE_PERMISSIONS_MANAGEMENT = '/permissions-management'

export function getAllRoles(axiosPrivate) {
  return axiosPrivate.get(`${BASE_PATH_ROLE_PERMISSIONS_MANAGEMENT}/roles`)
}

export function getAllMenus(axiosPrivate) {
  return axiosPrivate.get(`${BASE_PATH_ROLE_PERMISSIONS_MANAGEMENT}/menus`)
}

export function submitNewRole(axiosPrivate, params) {
  return axiosPrivate.post(`${BASE_PATH_ROLE_PERMISSIONS_MANAGEMENT}/roles/add`, params, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export function getRoleById(axiosPrivate, params) {
  const roleId = params.idRole
  return axiosPrivate.get(`${BASE_PATH_ROLE_PERMISSIONS_MANAGEMENT}/role/${roleId}`)
}

export function updateRole(axiosPrivate, id, params) {
  return axiosPrivate.put(`${BASE_PATH_ROLE_PERMISSIONS_MANAGEMENT}/role/${id}/update`, params, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export function deleteRole(axiosPrivate, id) {
  return axiosPrivate.delete(`${BASE_PATH_ROLE_PERMISSIONS_MANAGEMENT}/role/${id}`)
}

export function getSystemPermissions(axiosPrivate) {
  return axiosPrivate.get(`/system-permissions`)
}
